export const help = {
  title: 'Centre d\'aide',
  subtitle: 'Modes opératoires et ressources pour l\'utilisation de Domanys',
  tab_bo: 'Back-office',
  tab_mobile: 'Application mobile',
  tab_excel: 'Conversion heures',
  bo_title: 'Mode opératoire - Back-office',
  bo_description: 'Guide complet pour le paramétrage et l\'exploitation du back-office (création de comptes, plannings, interventions, exports).',
  mobile_title: 'Mode opératoire - Application mobile',
  mobile_description: 'Guide d\'utilisation de l\'application mobile pour les équipes terrain (connexion, scan QR code, saisie manuelle, prestations hors planning).',
  excel_title: 'Outil de conversion d\'heures',
  excel_description: 'Fichier Excel pour convertir les heures centièmes en heures/minutes et faciliter la saisie des plannings.',
  download: 'Télécharger',
  download_pdf: 'Télécharger le PDF',
  download_excel: 'Télécharger le fichier Excel',
  preview_unavailable: 'L\'aperçu n\'est pas disponible pour ce format. Cliquez sur "Télécharger" pour ouvrir le fichier.',
};
